import { useRef } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { WHO_SEES_NOTE } from './DestinationCard';

// The prompt text of spec 9.4. The sentences about upcoming bookings show only when there
// are some (R2-S-016). The last sentence says who sees the customer's details (R2-P-008).
export function promptBody(upcoming) {
  const sentences = ['FlowBookings adds each approved booking as an event and keeps it up to date.'];
  if (upcoming > 0) {
    const bookings = upcoming === 1 ? 'booking' : 'bookings';
    sentences.push(
      `It starts with your ${upcoming} upcoming approved ${bookings} now. With many, this can take some hours.`
    );
  }
  sentences.push(WHO_SEES_NOTE);
  return sentences.join(' ');
}

// The prompt after a connect (R1-L5-003). `destination` is the view's `askDestination`.
// The dialog renders outside the page root, so it carries amp-block itself (R1-L3-002).
// It does not give focus back on close, so "Choose another calendar" leaves focus in the picker.
export default function DestinationPrompt({ destination, upcoming, isSaving, onNotNow, onChoose, onYes }) {
  // Keeps the calendar name in the title while the dialog fades out.
  const lastDestination = useRef(null);
  if (destination) lastDestination.current = destination;
  return (
    <Dialog
      className="amp-block"
      open={Boolean(destination)}
      onClose={() => !isSaving && onNotNow()}
      disableRestoreFocus
    >
      <DialogTitle>Add your approved bookings to {lastDestination.current?.name}?</DialogTitle>
      <DialogContent>
        <Typography variant="body2">{promptBody(upcoming)}</Typography>
      </DialogContent>
      <DialogActions sx={{ flexWrap: 'wrap', rowGap: 1 }}>
        <Button variant="outlined" color="inherit" disabled={isSaving} onClick={onNotNow}>
          Not now
        </Button>
        <Button variant="outlined" disabled={isSaving} onClick={onChoose}>
          Choose another calendar
        </Button>
        <LoadingButton variant="contained" loading={isSaving} onClick={onYes}>
          Yes
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
